module.exports = __webpack_public_path__ + "media/src/assets/Images/Garage-859e63de8193d8389b563b3a658a2f7b.svg";